export default {
  integration: {
    groupBuying: {
      storeBindings: '门店绑定',
      notAvailable: '暂未开放',
      title: '团购管理',
      overview: '渠道概览',
      products: '团购商品',
      history: '券核销记录',
      historyNoAccess: '当前账号没有核销记录查询权限，请联系管理员开通后重新登录。',
      data: '团购数据',
      overviewUnavailable: '渠道概览尚未开放，可在渠道管理中管理授权账号。',
      mappingDescription: '管理门店与平台门店的绑定关系。',
      mappingUnavailable: '{platform}门店绑定暂未开放。',
      productsUnavailable: '团购商品管理尚未开放。',
    },
    connections: {
      authorizationTarget: '授权对象',
      storeAuthorization: '门店授权',
      meituanStoreGuide: '使用有权管理该门店的美团账号确认团购核销授权。授权成功后仍需完成智界门店绑定，才能开展门店业务。',
      storeAuthorizationUnavailable: '当前服务尚未开放美团门店授权，请联系管理员升级后重试。',
      meituanDisconnectImpact: '仅解除当前租户与所选美团主体的关联，停用该主体下的业务并结束针对它的重新授权申请。其他门店授权不受影响，不撤销美团侧授权。',
      startAuthorization: '发起授权',
      requestedBusinesses: '申请业务',
      noSession: '尚未发起授权，请先选择业务生成授权入口。',
      pendingSessionHint: '已有授权正在处理，请在第二步继续操作或查询结果。',
      sessionPartial: '部分完成，已确认的授权继续有效。',
      upgradeRequired: '当前服务版本不支持统一授权，请联系管理员升级后重试。',
      authorizedAccounts: '{platform}授权账号',
      noAuthorizedAccounts: '暂无{platform}授权账号',
      generateLink: '生成授权链接',
      submitApplication: '提交申请',
      cancelApplication: '取消申请',
      cancelApplicationConfirm: '仅结束智界中的这份申请，不会撤销快手侧授权。请先处理快手后台旧申请或授权，再重新填写正确的商家 ID。确定取消？',
      applicationCancelled: '已取消',
      cancelledNextStep: '这份智界申请已结束。处理快手侧旧申请或授权后，可重新发起并填写正确的商家 ID。',
      cancelApplicationProcessing: '申请已进入回调处理或状态已变化，无法取消，请查询授权结果。',
      cancelApplicationUnknown: '未能确认取消结果，请查询授权结果或重试取消。',
      kuaishouUserIdHelp: '填写快手生活服务商家 ID；商家主账号的快手 ID 由运营在快手后台发起授权时填写。',
      collapseOperation: '收起操作',
      preparationReady: '准备完成，请继续完成品牌授权。',
      manageAccountHint: '请在下方账号列表中添加业务或重新授权。',
      kuaishouUserId: '快手商家 ID',
      kuaishouUserIdInvalid: '请填写数字格式的快手商家 ID。',
      manualAuthorizationGuide: '填写商家 ID 提交申请后联系运营。运营核实归属，并在快手后台填写商家主账号快手 ID 发起授权后，请使用商家主账号前往快手商家中心「店铺管理 → 应用授权」完成授权，系统会自动关联，再返回查询结果。',
      applicationExpires: '有效期至 {expires}',
      authorizationGuide: '{platform}授权引导',
      authorizedBusinesses: '已授权业务及状态',
      accountId: '账号 ID',
      singleAccountHint: '如需更换账号，请先解除原账号关联。',
      sameAccountBusiness: '请使用当前账号开通新业务，不能通过添加业务更换账号。',
      reauthorizeHint: '请重新授权恢复使用',
      guideSteps: {
        authorize: { title: '生成授权链接', description: '选择需要开通的业务，生成链接后前往平台授权。' },
        merchant: { title: '填写商家信息', description: '填写快手生活服务商家 ID，提交授权申请。' },
        result: { title: '品牌授权', description: '使用平台管理员账号确认授权，然后返回本页查询授权结果。' },
        stores: { title: '门店绑定', description: '建立智界门店与平台门店的对应关系。' },
        products: { title: '团购项目绑定', description: '建立智界项目与平台团购商品的对应关系。' },
      },
      business: '业务／方案',
      businessUnknown: '业务信息未提供',
      addBusiness: '新增业务',
      businesses: { KUAISHOU_GROUP_BUY: '团购业务', MEITUAN_58: '团购核销', DOUYIN_16: '到综团购', DOUYIN_21: '餐饮团购' },
      reauthorize: '重新授权',
      appendScope: '请使用当前账号重新授权，完成后更新授权状态。',
      apiPermissions: '接口使用权限',
      permissionsHint: '权限仅适用于已授权资源，以最近同步结果为准。取得权限不表示对应功能已经开放。',
      permissionsUnavailable: '当前不可用',
      permissionsEmpty: '暂无可用接口权限',
      permissionsMissing: '权限信息未提供',
      permissionNames: {
        DOUYIN: { 1: '门店管理', 16: '商户授权', 139: '团购核销', 140: '核销对账', 144: '商品查询', 175: '餐饮团购核销', 176: '餐饮核销对账', 180: '餐饮商品查询' },
        MEITUAN: { tuangou: '团购', shangpin: '商品管理' },
      },
      restoreScope: '请使用原账号重新完成本项业务授权。本次只恢复实际确认的范围，不自动恢复以前的全部权限。',
      queryAuthorization: '查询授权结果',
      restoreConnection: '恢复关联',
      chooseRestoreAccount: '请在下方选择原账号恢复关联。',
      linkOtherAccount: '关联其他账号',
      connectionState: '关联状态',
      businessNotOpen: '本版本暂未开放',
      douyinManageAccountHint: '请在下方对应账号行重新授权或解除关联。',
      authorizationResultUnknown: '暂时无法确认授权申请结果，请查询原申请后再操作。',
      douyinDisconnectImpact: '仅解除当前租户与该账号的关联，停用其全部业务并结束同一平台的待授权申请。不撤销抖音侧授权，不影响其他人工配置的租户关系。',
      douyinDisconnectUnknown: '暂时无法确认解除结果，当前显示上次确认的状态。请在第二步查询授权结果后再操作。',
      douyinResultGuide: '查询云端已接收的授权结果和账号关联状态。此操作不实时查询抖音权限。',
      connectionSyncPending: '授权成功，关联信息同步中。',
      douyinFailureNextStep: '如需恢复原账号，请在账号列表中选择恢复关联或重新授权；接入其他账号请重新发起。',
      title: '渠道管理',
      description: '按平台管理授权账号，查看业务状态及门店绑定。',
      noAccess: '当前账号没有渠道管理查看权限，请联系管理员开通后重新登录。',
      addAuthorization: '新增授权',
      goAuthorize: '前往平台授权',
      authorizationUnavailable: '{platform}授权入口尚未开放。',
      authorizationReady: '{platform}可发起授权，请选择业务。',
      capabilityUnknown: '当前业务暂时无法授权，请刷新页面后重试。',
      capabilityLoadFailed: '暂时无法发起授权，请刷新页面后重试。',
      recoverAuthorization: '找回授权结果',
      awaitingList: '授权已完成。若账号尚未出现在列表中，请稍后刷新列表。',
      capabilityReasons: {
        MANUAL_STATE_UNVERIFIED: '快手人工授权尚未开放，请联系管理员。',
        ENTRY_UNAVAILABLE: '授权入口地址尚未配置完成，请联系管理员。',
        PROVIDER_UNAVAILABLE: '平台授权配置尚未就绪，请联系管理员。',
        BUSINESS_UNAVAILABLE: '该业务的授权能力尚未配置完成，请联系管理员。',
      },
      guides: {
        MEITUAN: '授权美团到店综合商家账号，用于后续团购门店与核销业务。',
        DOUYIN: '授权抖音生活服务商家账号，用于后续团购门店与核销业务。',
        KUAISHOU: '授权快手商家账号，用于后续团购门店与核销业务。',
      },
      platform: '平台',
      account: '商家账号',
      authorizationStatus: '授权状态',
      actions: '操作',
      reload: '刷新列表',
      refresh: '查询最新状态',
      refreshAccountInfo: '刷新账号信息',
      accountInfoRefreshed: '账号信息已更新',
      accountInfoUnavailable: '未获取到该账号名称，已保留原信息',
      accountInfoRefreshFailed: '账号信息刷新失败，已保留原信息，请稍后重试。',
      accountInfoRequiresAuthorization: '账号关联和授权有效时可刷新信息。',
      accountInfoRequiresShopPermission: '需要门店管理接口权限。',
      accountInfoRequiresUpgrade: '当前服务版本不支持账号信息刷新，请联系管理员升级后重试。',
      disconnect: '解除关联',
      confirm: '确认解除“{name}”与当前品牌的关联？',
      disconnectImpact: '解除后，当前品牌将停用该账号下的全部业务，并结束本品牌在同一平台的待授权申请。其他品牌不受影响，业务通知不会自动转交。',
      disconnectCurrentBrand: '确认解除关联',
      platformRevokeGuide: '如需同时解除所有使用该份授权的品牌，请前往平台商家后台解除授权，具体范围以平台提示为准。',
      platformPortalLinks: {
        MEITUAN: '前往美团经营宝',
        DOUYIN: '前往抖音来客',
        KUAISHOU: '前往快手商家中心',
      },
      loadFailed: '授权列表加载失败，请刷新列表重试。已有内容为上次加载的结果。',
      refreshFailed: '最新状态查询失败，当前显示上次确认的状态，请稍后重试。',
      retryAfterQuery: '已查询最新状态，授权尚未解除。如需解除，请重新确认操作。',
      unknownResult: '暂时无法确认解除结果，当前显示上次确认的状态。请查询最新状态后再操作。',
      platforms: {
        DOUYIN: '抖音',
        MEITUAN: '美团',
        KUAISHOU: '快手',
      },
      states: {
        DISCONNECTED: '已解除',
        AUTHORIZED: '已授权',
        REVOKED: '已撤销',
        INVALID: '已失效',
      },
    },
    pageTitle: '渠道管理',
    pageDesc: '管理小程序授权与版本。',

    wechatCardTitle: '微信小程序',
    douyinCardTitle: '抖音小程序',
    alipayCardTitle: '支付宝小程序',
    unionPayCardTitle: '云闪付小程序',
    xiaohongshuCardTitle: '小红书小程序',
    harmonyCardTitle: '鸿蒙元服务',
    notAuthorized: '尚未授权',
    notAuthorizedShort: '未授权',
    notAuthorizedDesc: '授权后，小程序就能使用本品牌的门店、商品和会员服务。',
    douyinDesc: '点击去授权后，请按抖音页面提示完成绑定。',
    waitingAuthorization: '待授权',
    noMiniProgramTip: '没有小程序？',
    registerNow: '去注册',
    customize: '定制小程序',
    customizeDesc: '自定义小程序页面布局与展示内容。',
    customizeAuthorizedDesc: '调整小程序页面布局，配置轮播图、商品展示与导航入口，打造符合品牌风格的小程序。',
    authorizeNow: '去授权',
    scanToVisit: '微信“扫一扫”访问小程序',
    qrCodeAlt: '微信小程序码',
    qrCodeUnavailable: '暂无小程序码',
    qrCodeUnavailableDesc: '小程序码暂未生成，可点击“刷新小程序码”重试。',
    refreshQrCode: '刷新小程序码',
    refreshQrCodeSuccess: '小程序码已刷新',
    downloadQrCode: '下载小程序码',
    downloadQrCodeSuccess: '小程序码已下载',
    downloadQrCodeFailed: '小程序码下载失败，请重试',

    appName: '小程序名称',
    externalAppId: '小程序 AppID',
    principalName: '主体名称',
    miniProgramIntroduction: '小程序简介',
    authorizationId: '授权ID',
    status: '授权状态',
    revision: '版本号',
    lastSyncedTime: '最近同步时间',

    statusAuthorized: '已授权',
    statusRevoked: '已撤销',
    statusInvalid: '已失效',

    startAuth: '发起授权',
    reAuth: '重新授权当前小程序',
    refreshMirror: '刷新授权状态',
    refreshSuccess: '授权状态已刷新',
    refreshRemoteMissing: '暂未查询到有效授权，请确认平台授权已完成',
    deauthorizationGuide: '解除授权指引',
    deauthorizationGuideTitle: '解除微信小程序授权',
    deauthorizationGuideNotice: '微信要求由小程序管理员在微信公众平台完成解除授权，服务商无法代为操作。',
    deauthorizationGuideStep1: '使用小程序管理员账号登录微信公众平台。',
    deauthorizationGuideStep2: '进入“设置 → 第三方设置”。',
    deauthorizationGuideStep3: '找到当前授权的第三方平台，并按页面指引解除授权。',
    deauthorizationGuideResult: '解除成功后，授权状态将自动更新为“已撤销”。',
    openWechatPublicPlatform: '打开微信公众平台',

    manageMiniProgram: '管理小程序',
    managePageTitle: '管理小程序',
    managePageDesc: '查看微信小程序授权信息，并提交或发布小程序版本。',
    basicInfoTitle: '基本信息',
    basicInfoDesc: '当前已授权的小程序信息。',
    refreshBasicInfo: '刷新基本信息',
    refreshBasicInfoSuccess: '基本信息已刷新',
    authorizationPlatform: '授权平台',
    noAuthorizedMiniProgram: '暂无已授权的小程序信息',
    versionInfoTitle: '版本管理',
    versionInfoDesc: '提交后，系统会上传最新小程序版本并送微信审核。',
    queryAuditStatus: '查询审核状态',
    queryAuditStatusSuccess: '审核状态已更新',
    versionOperationResultUnknown: '操作结果暂时无法确认，请先查询最新状态。',
    versionOperationRetryAvailable: '暂未确认新的处理结果，可再次查询，或重试原操作。',
    queryOperationStatus: '查询最新状态',
    retrySubmitVersion: '重试提交',
    retryReleaseVersion: '重试发布',
    reload: '重新加载',
    authorizationLoadFailed: '授权信息加载失败',
    authorizationRefreshFailed: '授权信息刷新失败，当前显示上次获取的信息',
    versionLoadFailed: '版本信息加载失败',
    versionRefreshFailed: '版本信息刷新失败，当前显示上次获取的信息',
    qrCodeLoadFailed: '小程序码加载失败，请刷新重试',
    qrCodeRefreshFailed: '小程序码刷新失败，当前显示上次获取的小程序码',
    latestVersionLoadFailed: '最新版本查询失败，请重试',
    versionOperationFailed: '版本操作失败',
    versionFailureNextStep: '请根据失败原因处理，再使用上方可用操作继续。',
    versionInformationUnavailable: '暂无版本信息',
    viewAuthorizationProgress: '查看授权进度',
    authorizationPollingFailed: '暂时无法获取授权进度，正在重试',
    authorizationCloseHint: '关闭此窗口后，仍可在平台页面继续授权；返回后可查看授权进度。',
    authorizationEntryUnavailable: '授权入口暂不可用，请关闭后重新查看授权进度。',
    submitNewVersion: '提交新版本',
    releaseVersion: '发布版本',
    submitVersionConfirm: '确认提交新的小程序版本给微信审核吗？',
    releaseVersionConfirm: '确认发布这个已通过审核的小程序版本吗？',
    submitVersionSuccess: '新版本任务已提交',
    releaseVersionSuccess: '发布任务已提交',
    noVersionTask: '暂无版本任务',
    noVersionTaskDesc: '还没有提交记录。提交新版本后，可在这里查看审核进度。',
    reviewProgressTitle: '版本审核进度',
    reviewStepSubmit: '提交审核',
    reviewStepWechat: '微信审核',
    reviewStepResult: '审核结果',
    reviewPassed: '审核通过',
    reviewTipPending: '提交审核后，可在当前页查看审核状态。微信一般会在 3-4 个工作日内完成审核，具体以微信审核结果为准。',
    reviewTipReviewing: '微信一般会在 3-4 个工作日内完成审核。当前仍在常规审核时间内，请查询审核状态。',
    reviewTipOverdue: '本次审核已超过 4 个工作日。请以微信审核结果为准，并查询审核状态。',
    reviewTipPassed: '最新版本已通过微信审核，可以发布版本。',
    currentOnlineVersion: '当前线上版本',
    onlineReleaseTime: '上次发布时间',
    latestAvailableVersion: '开放平台最新版本',
    latestVersionNotFetched: '未获取',
    getLatestVersion: '获取最新版本',
    getLatestVersionSuccess: '已获取最新版本',
    checkingUpgradeAvailability: '正在检查新版本',
    alreadyLatestVersion: '当前已是最新版本',
    taskTemplateVersion: '上次提审版本',
    versionStatus: '版本状态',
    submittedTime: '上次提审时间',
    statusSubmitting: '正在提交新版本',
    statusUnderReview: '微信审核中',
    statusReviewRejected: '审核未通过',
    statusReadyToRelease: '审核通过，待发布',
    statusReleasing: '正在发布',
    statusReleaseFailed: '发布失败，可重新发布',
    statusReleased: '已发布',
    statusFailed: '版本操作失败',

    authDialogTitle: '完成授权',
    authDialogTip: '请在新打开的页面中登录平台管理员账号并完成授权。没有看到新页面时，可点击下方按钮重新打开。',
    authEntryExpireAt: '请在此时间前完成授权',
    openEntryUrl: '打开授权页面',

    sessionStatus: '会话状态',
    sessionPending: '等待授权中…',
    sessionAuthorized: '授权成功',
    sessionFailed: '授权失败',
    sessionExpired: '授权链接已过期',
    failureReason: '失败原因',
    createSessionFail: '授权页面打开失败，请稍后重试',
    sessionRecoveryUnavailable: '未找到原授权会话或会话已过期，请再次点击授权重新发起',
    done: '完成',
  },
};
